module.exports = __webpack_public_path__ + "static/menu-Dance-669a7565e8f6e5a749c9640f435e7daa.png";